import { render, staticRenderFns } from "./Cartoon.vue?vue&type=template&id=2ab77c6f"
import script from "./Cartoon.vue?vue&type=script&lang=js"
export * from "./Cartoon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports